module.exports = __webpack_public_path__ + "static/media/10.9a605933.jpg";